import React from 'react';
import { MapPin, Mail, Clock, Calendar, Phone } from 'lucide-react';
import { Button } from '../ui/button';
import CalendlyPopup from '../CalendlyPopup';
import { useCalendlyAndVideo } from '../../hooks/useCalendlyAndVideo';

const ContactInfo = () => {
  const { isCalendlyOpen, openCalendly, closeCalendly } = useCalendlyAndVideo();

  const contactDetails = [
    {
      icon: MapPin,
      title: 'Headquarters / Eastern Division',
      details: [
        'Traain',
        '1343 Main Street',
        'Suite 205',
        'Sarasota, FL 34236'
      ]
    },
    {
      icon: MapPin,
      title: 'Western Division',
      details: [
        'Traain',
        '215 N Maple St',
        'Suite #23',
        'Florence, CO 81226'
      ]
    },
    {
      icon: Phone,
      title: 'Phone',
      details: [
        '720-740-6767'
      ]
    },
    {
      icon: Mail,
      title: 'Email',
      details: [
        'support@traain.com'
      ]
    },
    {
      icon: Clock,
      title: 'Business Hours (EST)',
      details: [
        'Monday - Friday: 9:00 AM - 5:00 PM EST',
        'Saturday - Sunday: Closed'
      ]
    }
  ];

  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-3xl font-bold text-white mb-6">Contact Information</h2>
        <p className="text-gray-400 mb-8">
          Prefer a different way to reach us? We&apos;re here to help however works best for you.
        </p>
      </div>

      <div className="space-y-6">
        {contactDetails.map((item, index) => (
          <div
            key={index}
            className="bg-gray-900 rounded-xl p-6 border border-gray-800 hover:border-gray-700 transition-colors"
          >
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-blue-900/30 border border-blue-700 rounded-xl flex items-center justify-center flex-shrink-0">
                <item.icon className="w-6 h-6 text-blue-400" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-white mb-2">{item.title}</h3>
                {item.details.map((detail, idx) => (
                  <p key={idx} className="text-gray-400 text-sm">
                    {detail}
                  </p>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Schedule Demo CTA */}
      <div className="bg-gradient-to-r from-blue-900/30 to-indigo-900/30 rounded-2xl p-8 border border-blue-800">
        <div className="flex items-start gap-4 mb-6">
          <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center flex-shrink-0">
            <Calendar className="w-6 h-6 text-white" />
          </div>
          <div>
            <h3 className="text-xl font-bold text-white mb-2">
              Schedule a Demo
            </h3>
            <p className="text-gray-300 text-sm">
              See Traain in action with a personalized walkthrough tailored to your team&apos;s needs.
            </p>
          </div>
        </div>
        <Button
          size="lg"
          onClick={openCalendly}
          className="w-full bg-blue-600 hover:bg-blue-700"
        >
          Book Your Demo
        </Button>
      </div>
      
      <CalendlyPopup isOpen={isCalendlyOpen} onClose={closeCalendly} />
    </div>
  );
};

export default ContactInfo;
